import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgOption } from '@ng-select/ng-select';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/Service/auth.service';
import { CaeUserService } from 'src/app/Service/cae-user-service.service';
import { ErrorCustomService } from 'src/app/Service/error-service.service';
import { EventService } from 'src/app/Service/event.service';
import { PaginationTableService } from '../../shared/pagination/pagination-table/pagination-table.service';
import { utilsApps } from 'src/app/helpers/utils-app';

@Component({
  selector: 'app-list-record-cae-user',
  templateUrl: './list-record-cae-user.component.html'
})
export class ListRecordCaeUserComponent implements OnInit {

  //Nuevas variables para los componentes nuevos
  public totalPage: number = 1;
  public actualPage: number = 1;
  public dataRegisterSelected: any;

  dataInformation = <any>[];
  resetTable = false;
  emptyDataList: boolean = true;
  IsPostBack = false;
  msgDataEmpty: string = "El criterio de búsqueda ingresado no existe.";
  idEntity: string = "0";
  branches: NgOption[] = [];
  currentUser: any;
  currentApiKey: string;
  data: any;
  selected: any[];


  catStatus = [
    { isChecked: false, id: -1, description: 'Todos', keyLg: "All" },
    { isChecked: false, id: 1, description: 'Enable', keyLg: "Enable" },
    { isChecked: false, id: 0, description: 'Disable', keyLg: "Disable" }
  ];



  /** Variables of pagination */
  protected totalPages: any[] = [];
  protected currentPage: number = 1;
  totalItems: number;


  constructor(
    private readonly _modalService: NgbModal,
    protected eventService: EventService,
    private readonly _service: CaeUserService,
    private readonly translate: TranslateService,
    private readonly _errorS: ErrorCustomService,
    private readonly authService: AuthService,
    private readonly paginationTableService: PaginationTableService,
    private readonly _config: NgbModalConfig) {
    //Configuración para modal global
    _config.backdrop = 'static';
    _config.keyboard = false;

    this.authService.currentUser.subscribe(resp => {
      if (resp === null || resp.username === undefined)
        this.currentUser = null;
      else
        this.currentUser = resp;
    });
    this.currentApiKey = this.currentUser.apiKey;
    this.selected = [this.currentUser.branches[0].id.toString()];
  }

  public getDateInitMonth() {
    let currentDate = new Date();
    return new Date(
      currentDate.getFullYear() + '/' + (currentDate.getMonth() + 1) + '/01'
    );
  }

  ngOnInit(): void {
    try {
      this.getDataLanguage();
      this.currentPage = parseInt(localStorage.getItem('currentPage') ?? this.paginationTableService.resetPageCurrent().toString());

      this.onLoadGrid(false);
    } catch (error) {
      console.log('Error: ' + error);
    }
  }

  getDataLanguage() {
    this.catStatus.forEach(element => {
      this.translate.stream('cae-user.catStatus.' + element.keyLg).subscribe((res: string) => {
        element.description = res;
      });
    });
  }

  onOpen(content: any) {
    this._modalService.open(content, { size: 'xl' });
  }

  onDownload(jobId: string) {
    this.eventService.startLoadingData();
    try {

      this._service.GetReportByJobId(jobId).subscribe({
        next: res => {
          console.log(res);
          let result = res.body;
          if (res.status == 200) {
            if (result.code == "SUCCESS") {
              let _fileName = "report_failed-persons_" + jobId;
              let _utils = new utilsApps();
              let content = result.content;
              _utils.downloadFileFromB64(content, _fileName, '.xlsx');
            } else {
              this.eventService.errorMessage();
            }
          }
          this.eventService.completeLoadingData();

        },
        error: error => {
          console.log(error);
          let _errorMsj = "Ha ocurrido un error al intentar descargar los datos. Por favor consulte a su administrador.";
          let _errorKey = 'common.error500_download';

          if (error.status == 500) {
            _errorKey = "common.error500_download_file";
          }
          else if (error.status == 0) {
            _errorKey = "common.error0_download";
          }

          this.translate.stream(_errorKey).subscribe((res: string) => {
            console.log(res);
            _errorMsj = res;
          });

          this.eventService.errorMessage(0, _errorMsj);
          this.eventService.completeLoadingData();
        }
      });

    } catch (error) {
      console.log(error);
      this.eventService.completeLoadingData();
    }
  }


  onUpload(content: any) {
    this._modalService.open(content, { size: 'xl' });
  }



  getParameters(): string {
    let filter = "companyId=" + this.currentUser.branches[0].idCompany;

    console.log(filter);

    return filter;
  }

  onLoadGrid(isFilterByUser: boolean) {

    if (isFilterByUser) {
      this.currentPage = this.paginationTableService.resetPageCurrent();
    }

    this.eventService.startLoadingData();
    let _parametros = this.getParameters();

    console.log("page=> ", this.currentPage);
    console.log("_parametros=> ", _parametros);

    this._service.GetUserCaeHistoryList(_parametros, this.currentPage).subscribe({
      next: res => {
        console.log("res=> ", res);

        if (res.ok) {
          let resultData = res.body;
          let rowData = resultData.content;

          console.log("contentJson=> ", rowData);

          this.dataInformation = rowData;
          this.totalPages = resultData.totalPages;
          this.totalItems = resultData.totalElements;
          this.resetTable = false;
          localStorage.setItem('isInitLoad', '0');
          this.emptyDataList = rowData.totalElements == 0;
          this.IsPostBack = true;
        }
        else {

          this.translate.stream('common.error500').subscribe((res: string) => {
            this.eventService.errorMessage(0, res);
          });

        }

        this.eventService.completeLoadingData();
      },
      error: error => {
        console.log(error);
        this.eventService.completeLoadingData();
        this.eventService.errorMessage(1);
      }
    });

  }


  onSyncItem(id: string, content: any) {
    this.idEntity = id.toString();
  }

  protected changePage($event: any): void {
    this.currentPage = $event;
    this.onLoadGrid(false);
  }



  onChangeBranch(event: any) {
    console.log(event);
    // this.currentBranchId = event.value;
    // this.branchId = event.value;
    // localStorage.setItem('_branch', this.branchId);
    // this.loadUsersForBranch(event.value);
  }



  public b64toBlob(b64Data, contentType) {

    contentType = contentType || '';
    let sliceSize = 512;

    let byteCharacters = atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    let blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }



  //Outputs de los componentes

  public onSearch(dataForm: any) {
    console.log(dataForm);
  }



}
